import React from 'react'

const MedicalLanding = () => {
    return (
        <div className="container-fluid body-content">Medical Landing Page</div>
    )
}

export default MedicalLanding